import _add from "lodash/add";
import _assign from "lodash/assign";
import _assignWith from "lodash/assignWith";
import _chunk from "lodash/chunk";
import _clamp from "lodash/clamp";
import _cloneDeep from "lodash/cloneDeep";
import _countBy from "lodash/countBy";
import _difference from "lodash/difference";
import _each from "lodash/each";
import _every from "lodash/every";
import _filter from "lodash/filter";
import _find from "lodash/find";
import _findIndex from "lodash/findIndex";
import _first from "lodash/first";
import _flatMap from "lodash/flatMap";
import _flatten from "lodash/flatten";
import _forEach from "lodash/forEach";
import _forOwn from "lodash/forOwn";
import _fromPairs from "lodash/fromPairs";
import _groupBy from "lodash/groupBy";
import _hasIn from "lodash/hasIn";
import _includes from "lodash/includes";
import _intersection from "lodash/intersection";
import _intersectionBy from "lodash/intersectionBy";
import _isEmpty from "lodash/isEmpty";
import _isEqual from "lodash/isEqual";
import _isFinite from "lodash/isFinite";
import _isString from "lodash/isString";
import _isUndefined from "lodash/isUndefined";
import _kebabCase from "lodash/kebabCase";
import _keys from "lodash/keys";
import _last from "lodash/last";
import _map from "lodash/map";
import _mapKeys from "lodash/mapKeys";
import _max from "lodash/max";
import _maxBy from "lodash/maxBy";
import _memoize from "lodash/memoize";
import _min from "lodash/min";
import _omit from "lodash/omit";
import _omitBy from "lodash/omitBy";
import _orderBy from "lodash/orderBy";
import _partialRight from "lodash/partialRight";
import _pick from "lodash/pick";
import _pickBy from "lodash/pickBy";
import _pull from "lodash/pull";
import _pullAll from "lodash/pullAll";
import _range from "lodash/range";
import _reduce from "lodash/reduce";
import _remove from "lodash/remove";
import _reverse from "lodash/reverse";
import _size from "lodash/size";
import _some from "lodash/some";
import _sortBy from "lodash/sortBy";
import _split from "lodash/split";
import _takeRightWhile from "lodash/takeRightWhile";
import _takeWhile from "lodash/takeWhile";
import _times from "lodash/times";
import _toPairs from "lodash/toPairs";
import _toUpper from "lodash/toUpper";
import _trim from "lodash/trim";
import _unescape from "lodash/unescape";
import _union from "lodash/union";
import _uniq from "lodash/uniq";
import _values from "lodash/values";
import _without from "lodash/without";
import _xor from "lodash/xor";
import _zipObject from "lodash/zipObject";

export const add = _add;
export const assign = _assign;
export const assignWith = _assignWith;
export const chunk = _chunk;
export const clamp = _clamp;
export const cloneDeep = _cloneDeep;
export const countBy = _countBy;
export const difference = _difference;
export const each = _each;
export const every = _every;
export const filter = _filter;
export const find = _find;
export const findIndex = _findIndex;
export const first = _first;
export const flatMap = _flatMap;
export const flatten = _flatten;
export const forEach = _forEach;
export const forOwn = _forOwn;
export const fromPairs = _fromPairs;
export const groupBy = _groupBy;
export const hasIn = _hasIn;
export const includes = _includes;
export const intersection = _intersection;
export const intersectionBy = _intersectionBy;
export const isEmpty = _isEmpty;
export const isEqual = _isEqual;
export const isFinite = _isFinite;
export const isString = _isString;
export const isUndefined = _isUndefined;
export const kebabCase = _kebabCase;
export const keys = _keys;
export const last = _last;
export const map = _map;
export const mapKeys = _mapKeys;
export const max = _max;
export const maxBy = _maxBy;
export const memoize = _memoize;
export const min = _min;
export const omit = _omit;
export const omitBy = _omitBy;
export const orderBy = _orderBy;
export const partialRight = _partialRight;
export const pick = _pick;
export const pickBy = _pickBy;
export const pull = _pull;
export const pullAll = _pullAll;
export const range = _range;
export const reduce = _reduce;
export const remove = _remove;
export const reverse = _reverse;
export const size = _size;
export const some = _some;
export const sortBy = _sortBy;
export const split = _split;
export const takeRightWhile = _takeRightWhile;
export const takeWhile = _takeWhile;
export const times = _times;
export const toPairs = _toPairs;
export const toUpper = _toUpper;
export const trim = _trim;
export const unescape = _unescape;
export const union = _union;
export const uniq = _uniq;
export const values = _values;
export const without = _without;
export const xor = _xor;
export const zipObject = _zipObject;

function customizer(objValue, srcValue) {
    return isUndefined(objValue) ? srcValue : objValue;
}
export const defaults = partialRight(assignWith, customizer) as <T>(...obj: Partial<T>[]) => T;
